import React, { forwardRef } from "react";
import styled from "styled-components";
import IEditableProps from "../../utilities/IEditableProps";
import IStyledProps from "../../utilities/IStyledProps";
import classNames from "classnames";

export interface IContentProps extends IEditableProps, IStyledProps {
    underhang?: boolean;
    children;
    noBorder?: boolean;
}

const Content = forwardRef((props: IContentProps, ref: any) => {
    const { className, underhang, children, editorClassObj, cmsId, noBorder } = props;

    return (
        <div data-id={cmsId} ref={ref} className={classNames("container", "content", className, editorClassObj, { underhang, 'no-border': noBorder })}>
            {children}
        </div>
    );
});

export default styled(Content)`
    position: relative;
    padding: 0;

    &.no-border {
        border-top: none !important;
    }

    &:empty {
        min-height: 250px;
    }
`;

(global as any).Content = Content;